import React from "react";
import { formatDateTime } from "../../common-data/Converts";

const BCASchedulerTemplates = ({ template, rowData }) => {
  const sortedTemplates = rowData?.templates
    ? [...rowData.templates].sort((a, b) => a.index - b.index)
    : [];

  return (
    <div className="bca_scheduler-templates-grid">
      {sortedTemplates.map((template) => (
        <div key={template.uid} className="bca_scheduler-template-card">
          <div className="bca_scheduler-template-header">
            <div className="bca_scheduler-template-title">
              <span className="bca_scheduler-template-index">
                Template {template.index}
              </span>

              <span className="bca_scheduler-template-name">
                {template.whatsapp_template_name}
              </span>
            </div>

            {template.whatsapp_template_body && (
              <div className="bca_scheduler-template-body-preview">
                <div style={{ whiteSpace: "pre-line" }}>
                  {template.whatsapp_template_body}
                </div>
              </div>
            )}
          </div>

          <div className="bca_scheduler-template-variables">
            <div className="bca_scheduler-template-variables-header">
              <span className="bca_scheduler-template-variables-title">
                Template Variables
              </span>
              {/* Add your icon here if needed */}
            </div>
            <div className="bca_scheduler-template-variables-grid">
              {template.whatsapp_variable_json.map((variable, idx) => (
                <div key={idx} className="bca_scheduler-variable-field">
                  <label className="bca_scheduler-variable-label">
                    Key: {variable.key}
                  </label>
                  <select className="bca_scheduler-variable-select" disabled>
                    <option>
                      {variable.variableName
                        ? variable.variableName
                        : "Select Variable"}
                    </option>
                  </select>
                </div>
              ))}
            </div>
          </div>

          <div className="bca_scheduler-template-footer">
            <span className="bca_scheduler-template-date">
              Date Added:{" "}
              {template.date_added ? formatDateTime(template.date_added) : "-"}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BCASchedulerTemplates;
